import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { NotificationService } from 'src/app/utils/notification.service';
import { environment } from 'src/environments/environment';
import { FileDetail } from '../../models/common';

@Component({
  selector: 'app-image-upload-ui',
  templateUrl: './image-upload-ui.component.html',
  styleUrls: ['./image-upload-ui.component.css'],
})
export class ImageUploadUiComponent implements OnInit, OnChanges, OnDestroy {
  @Input() label: string = $localize`:@@photo:Photo`;
  @Input() fetchedPhoto: string;
  @Input() resetForm;
  @Input() componentName: string = '';
  @Input() isViewMode: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() isMultiple: boolean = false;
  @Input() disabled: boolean = false;
  @Input() acceptedFileTypes: string = '.png, .jpeg, .jpg';
  @Input() buttonValue: string = $localize`:@@photo:Photo`;
  public buttonPrefix:string = $localize`:@@upload:Upload`
  @Input() set defaultFiles(file: File | null) {
    if (!file) return
    this.filePreview = { file, url: this.createUrl(file) }
  }
  @Output() fileChangeEmit: EventEmitter<any> = new EventEmitter();
  @Output() fileEmit: EventEmitter<any> = new EventEmitter();
  // @Output() fileChangeEmit: EventEmitter<string|ArrayBuffer> = new EventEmitter();

  public files: FileDetail | null;
  public filePreview: FileDetail | null = null;
  public filesArray = [];
  private subscription: Subscription = new Subscription();
  public imgUrl: string = environment.baseUrl + environment.coreUrl + 'data/';
  public srcImage;
  private fetchedPhotoObjectUrl: string;
  constructor(
    private sanitizer: DomSanitizer,
    private toast: NotificationService,
    private http: HttpClient,
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.resetForm) {
      this.filePreview = null;
    }
  }

  ngOnInit(): void {
    if (this.fetchedPhoto) {
      this.buttonPrefix = $localize`:@@change:Change`
      this.loadFetchedPhoto();
    }
  }

  // The data endpoint requires the auth token from WizerHttpInterceptor, which a plain
  // <img src> request can't send, so the photo is fetched via HttpClient and turned into
  // an object URL instead of binding the endpoint URL directly.
  private loadFetchedPhoto() {
    this.subscription.add(
      this.http
        .get(this.imgUrl + this.fetchedPhoto, { responseType: 'blob' })
        .subscribe({
          next: (blob) => {
            this.fetchedPhotoObjectUrl = URL.createObjectURL(blob);
            this.srcImage = this.sanitizer.bypassSecurityTrustUrl(
              this.fetchedPhotoObjectUrl,
            );
          },
          error: () => {
            this.srcImage = null;
          },
        }),
    );
  }

  public upload(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = input.files;
    if (files.length > 0) {
      const file: File = files[0];
      const fileName: string[] = file.name.split('.');
      const type = fileName[fileName.length - 1];
      const name: string = fileName.slice(0, -1).join('');
      const size = Math.trunc(file.size / 1024)
      if (size > 1000) {
        return this.toast.error($localize`:@@maximum_photo_upload_is_1Mb:Maximum Photo Upload is 1Mb`);
      }
      this.files = {
        name,
        size: Math.trunc(file.size / 1024),
        file: file,
        url: this.createUrl(file),
        type,
      };
      this.fileEmit.emit(file)
      this.subscription.add(
        this.convertFile(file).subscribe(base64 => {
          this.fileChangeEmit.emit(base64);
        })
      );
      this.buttonPrefix = $localize`:@@change:Change`

      this.filePreview = this.files;
    }

  }

  private createUrl(file: File) {
    const fileName: string[] = file.name.split('.');
    const type = fileName[fileName.length - 1];
    return type !== 'pdf'
      ? this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file))
      : URL.createObjectURL(file)
  }



  // convert input file to base64
  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => result.next(event.target.result.toString());
    return result;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.fetchedPhotoObjectUrl) {
      URL.revokeObjectURL(this.fetchedPhotoObjectUrl);
    }
  }
}
